import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { useAppUpdateNotification } from '@/features/app-version/lib'
import { useNativeAppHandlers } from '@/features/native-app/lib'

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  component: RootComponent,
})

/**
 * Root component that provides the router outlet and essential providers
 */
function RootComponent() {
  // Initialise native app handlers
  useNativeAppHandlers()
  // Initialise app update notification system
  useAppUpdateNotification()

  return (
    <Outlet />
  )
}
